import React from "react";
import {TemplateArray} from "../../../components/FormTemplate/TemplateArray";
import {FormControl, FormHelperText} from "@material-ui/core";

export default (data, key) => {
    return (<FormControl fullWidth key={key} error={data.error ? true : false}>
        <TemplateArray key={key} data={data} onCallback={data.onCallback} />
        {data.error && (<FormHelperText>{data.error}</FormHelperText>)}
    </FormControl>)
}